(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-nsi-send-in-root]');

  if (!roots.length) {
    return;
  }

  function getParams() {
    return new URLSearchParams(window.location.search || '');
  }

  function safeTrim(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function setHidden(node, hidden) {
    if (node) {
      node.hidden = Boolean(hidden);
    }
  }

  function setText(node, text) {
    if (node) {
      node.textContent = text || '';
    }
  }

  function buildTransportUrl(endpoint, caseNumber, token) {
    var url = new URL(endpoint);

    url.searchParams.set('action', 'select_nsi_transport');
    url.searchParams.set('case_number', caseNumber);
    url.searchParams.set('token', token);
    url.searchParams.set('choice', 'bag');

    return url.toString();
  }

  function buildSummaryUrl(endpoint, caseNumber, token) {
    var url = new URL(endpoint);

    url.searchParams.set('action', 'get_nsi_send_in_summary');
    url.searchParams.set('case_number', caseNumber);
    url.searchParams.set('token', token);

    return url.toString();
  }

  function getJson(url) {
    return fetch(url, {
      method: 'GET',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Kunde inte hämta ärendeinformation.');
      }

      return response.json();
    });
  }

  function renderApprovedSummary(root, summary) {
    var summaryNode = root.querySelector('[data-nsi-send-in-summary]');
    var caseSummaryNode = root.querySelector('[data-nsi-send-in-case-summary]');
    var approvedCount = summary ? Number(summary.approved_count) || 0 : 0;

    if (!summaryNode || !caseSummaryNode) {
      return;
    }

    summaryNode.classList.remove('nsi-send-in__approved-card--loading', 'nsi-send-in__approved-card--error');
    caseSummaryNode.classList.remove('nsi-send-in__case-summary--loading', 'nsi-send-in__case-summary--error');
    caseSummaryNode.textContent = approvedCount > 0
      ? 'Detta ärende har ' + approvedCount + ' godkända ' + (approvedCount === 1 ? 'artikel.' : 'artiklar.')
      : 'Det finns inga godkända artiklar att skicka in för detta ärende.';

    summaryNode.hidden = false;
  }

  function renderSummaryError(root) {
    var summaryNode = root.querySelector('[data-nsi-send-in-summary]');
    var caseSummaryNode = root.querySelector('[data-nsi-send-in-case-summary]');

    if (!summaryNode || !caseSummaryNode) {
      return;
    }

    summaryNode.hidden = false;
    summaryNode.classList.remove('nsi-send-in__approved-card--loading');
    summaryNode.classList.add('nsi-send-in__approved-card--error');
    caseSummaryNode.classList.remove('nsi-send-in__case-summary--loading');
    caseSummaryNode.classList.add('nsi-send-in__case-summary--error');
    caseSummaryNode.textContent = 'Vi kunde inte hämta ärendet just nu. Prova att ladda om sidan eller kontakta oss så hjälper vi dig.';
  }

  function setButtonLabel(button, label) {
    if (button) {
      button.textContent = label;
    }
  }

  function addNsPaseToCart(variantId, caseNumber) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              'NSI-ärende': caseNumber
            }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart_add_failed');
      }

      return response.json();
    });
  }

  function redirectToNextStep(root, caseNumber) {
    var variantId = safeTrim(root.getAttribute('data-variant-id'));
    var productUrl = safeTrim(root.getAttribute('data-product-url')) || '/products/ns-pase';
    var redirectAfterAdd = safeTrim(root.getAttribute('data-redirect-after-add')) || 'checkout';
    var destination = redirectAfterAdd === 'cart' ? '/cart' : '/checkout';

    if (!variantId) {
      window.location.href = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'nsi_case=' + encodeURIComponent(caseNumber);
      return Promise.resolve();
    }

    return addNsPaseToCart(variantId, caseNumber).then(function () {
      window.location.href = destination;
    });
  }

  function init(root) {
    var params = getParams();
    var endpoint = safeTrim(root.getAttribute('data-endpoint'));
    var caseNumber = safeTrim(params.get('case_number')).toUpperCase();
    var token = safeTrim(params.get('token'));
    var caseNode = root.querySelector('[data-nsi-send-in-case-number]');
    var button = root.querySelector('[data-nsi-send-in-submit]');
    var errorNode = root.querySelector('[data-nsi-send-in-error]');
    var successNode = root.querySelector('[data-nsi-send-in-success]');
    var statusNode = root.querySelector('[data-nsi-send-in-status]');
    var isSubmitting = false;
    var summaryLoaded = false;
    var canOrderBag = false;
    var debugEnabled = params.get('nsi_debug') === 'true';
    var hasRequiredParams = Boolean(endpoint && caseNumber && token && caseNumber.indexOf('NSI-') === 0);
    var summaryFetchStart = window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : Date.now();

    setText(caseNode, caseNumber || 'Saknas');

    if (!hasRequiredParams) {
      setHidden(errorNode, false);
      if (button) {
        button.disabled = true;
        setButtonLabel(button, 'Beställ NS Påse');
      }
      return;
    }

    setHidden(errorNode, true);
    if (button) {
      button.disabled = true;
      setButtonLabel(button, 'Hämtar ärende...');
    }

    if (!button) {
      return;
    }

    setText(statusNode, 'Hämtar godkända artiklar...');

    if (debugEnabled) {
      console.log('NSI send-in summary fetch start', {
        case_number: caseNumber
      });
    }

    getJson(buildSummaryUrl(endpoint, caseNumber, token))
      .then(function (summary) {
        var summaryFetchEnd = window.performance && typeof window.performance.now === 'function'
          ? window.performance.now()
          : Date.now();
        var ctaReason = '';

        if (!summary || summary.status !== 'ok') {
          throw new Error(summary && summary.message ? summary.message : 'Kunde inte hämta ärendeinformation.');
        }

        renderApprovedSummary(root, summary);
        summaryLoaded = true;
        canOrderBag = Boolean(summary.can_order_bag && Number(summary.approved_count) > 0);

        if (!canOrderBag) {
          ctaReason = 'no_approved_articles_or_transport_not_offered';
          setText(errorNode, 'Det finns inga godkända artiklar att skicka in, eller så är transportval inte erbjudet för ärendet.');
          setHidden(errorNode, false);
          setText(statusNode, '');
          button.disabled = true;
          setButtonLabel(button, 'Beställ NS Påse');

          if (debugEnabled) {
            console.log('NSI send-in summary fetch complete', {
              duration_ms: Math.round(summaryFetchEnd - summaryFetchStart),
              summary_status: summary.status,
              approved_count: summary.approved_count,
              rejected_count: summary.rejected_count,
              cta_enabled: false,
              cta_disabled_reason: ctaReason
            });
          }
          return;
        }

        setText(statusNode, '');
        button.disabled = false;
        setButtonLabel(button, 'Beställ NS Påse');

        if (debugEnabled) {
          console.log('NSI send-in summary fetch complete', {
            duration_ms: Math.round(summaryFetchEnd - summaryFetchStart),
            summary_status: summary.status,
            approved_count: summary.approved_count,
            rejected_count: summary.rejected_count,
            cta_enabled: true,
            cta_disabled_reason: ''
          });
        }
      })
      .catch(function (error) {
        var summaryFetchEnd = window.performance && typeof window.performance.now === 'function'
          ? window.performance.now()
          : Date.now();

        renderSummaryError(root);
        setText(statusNode, '');
        button.disabled = true;
        setButtonLabel(button, 'Beställ NS Påse');

        if (debugEnabled) {
          console.log('NSI send-in summary fetch complete', {
            duration_ms: Math.round(summaryFetchEnd - summaryFetchStart),
            summary_status: 'error',
            cta_enabled: false,
            cta_disabled_reason: error && error.message ? error.message : 'summary_fetch_failed'
          });
        }
      });

    button.addEventListener('click', function () {
      var transportUrl;

      if (isSubmitting || !summaryLoaded || !canOrderBag) {
        return;
      }

      isSubmitting = true;
      button.disabled = true;
      setHidden(errorNode, true);
      setHidden(successNode, true);
      setText(statusNode, 'Kopplar ärendet och förbereder NS Påse...');

      try {
        transportUrl = buildTransportUrl(endpoint, caseNumber, token);
        if (debugEnabled) {
          console.log('NSI send-in transport request', {
            endpoint_url: endpoint,
            case_number: caseNumber,
            choice: 'bag',
            request_token_matches_url_token: new URL(transportUrl).searchParams.get('token') === token
          });
        }
      } catch (error) {
        isSubmitting = false;
        button.disabled = false;
        setText(statusNode, '');
        setText(errorNode, 'Tekniskt fel: endpoint saknas eller är felaktig.');
        setHidden(errorNode, false);
        return;
      }

      fetch(transportUrl, {
        method: 'GET',
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Transportvalet kunde inte registreras.');
          }

          return response;
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (!result || result.status !== 'ok') {
            throw new Error(result && result.message ? result.message : 'Transportvalet kunde inte registreras.');
          }

          setText(successNode, result.reason === 'already_selected'
            ? 'Transportvalet är redan registrerat. Vi skickar dig vidare.'
            : 'Transportvalet är registrerat. Vi skickar dig vidare.');
          setHidden(successNode, false);
          setText(statusNode, 'Går vidare till NS Påse...');

          return redirectToNextStep(root, caseNumber);
        })
        .catch(function (error) {
          isSubmitting = false;
          button.disabled = false;
          setText(statusNode, '');
          setText(errorNode, error && error.message
            ? error.message
            : 'Transportvalet kunde inte registreras. Kontrollera länken från kundbeskedet eller kontakta oss.');
          setHidden(errorNode, false);
        });
    });
  }

  Array.prototype.forEach.call(roots, init);
})();
